module.exports = require("core-js/library/fn/json/stringify");


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@babel_runtime-corejs2@7.17.7@@babel/runtime-corejs2/core-js/json/stringify.js
// module id = dT4d
// module chunks = 16